import Visualisation from "../../../components/visualisation/visualisation";
//import generateData from "../../../components/visualisation/generate-data";
//import { useTweaks, makeButton, makeSeparator } from "use-tweaks";
import { useState, useContext, useEffect, useRef } from "react";
import { SurveyContext } from "../../../store/survey-context";
import canvasScreenshot from "canvas-screenshot";
import BodyClassName from "react-body-classname";
import calcVisualisationData from "../../../calculations/visualisation";
import "./rings.scss";
import RingsView from "../../../components/ringsView/ringsView";
import { characteristics } from "../../../constants";
//import { mockData } from "./tempdata";
import Loader from "../../../components/loader/loader";
import { useTranslation } from "react-i18next";
import MacallanAPI from "../../../api/macallan.js";
import { setAppBackground } from "../../../utils";

export default function Rings(props) {
  // temporary - to play with some viz parameters
  const defaultLevels = {
    CL_Low: 0.3,
    CL_Medium: 0.5,
    CL_High: 0.7,
    CL_Double: 0.7,
    N_Weight: 1,
    NE_Weight: 1,
    E_Weight: 1,
    SE_Weight: 1,
    S_Weight: 1,
    SW_Weight: 1,
    W_Weight: 1,
    NW_Weight: 1,
  };

  const { t } = useTranslation("common");

  const [data, setData] = useState(null);

  const [stage, setStage] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [paused, setPaused] = useState(false);
  const [skipped, setSkipped] = useState(false);
  const [reset, setReset] = useState(0);

  const [isLargeScreen, setIsLargeScreen] = useState(
    window.matchMedia("(min-width: 768px)").matches
  );
  const [isVerticalViz, setIsVerticalViz] = useState(
    window.matchMedia("(max-width: 991px)").matches
  );

  const [slideContent, setSlideContent] = useState([]);

  const [dataChanged, setDataChanged] = useState(false);
  const [date, setDate] = useState("");

  const canvasRef = useRef();
  const debugCalculationsRef = useRef();

  const makeScreenshot = () => {
    requestAnimationFrame(async () => {
      //console.log("stage", stage);
      const screen = await canvasScreenshot(canvasRef.current, {
        download: false,
        type: "image/png",
      });
      const screenImg = new Image();
      screenImg.src = screen;
      await screenImg.decode();

      const bg = new Image();
      bg.src = `/textures/viz_image_background.jpg`;
      await bg.decode();

      const screenshotCanvas = document.createElement("canvas");
      screenshotCanvas.width = 1956;
      screenshotCanvas.height = 1024;
      Object.assign(screenshotCanvas.style, {
        position: "absolute",
        top: 0,
        left: 0,
        zIndex: 999,
        transform: "scale(0.3, 0.3)",
      });
      const ctx = screenshotCanvas.getContext("2d");
      ctx.drawImage(bg, 0, 0, 1956, 1024);
      if (isLargeScreen) {
        ctx.drawImage(screenImg, 340, -115, 1256, 1256);
      } else {
        ctx.drawImage(screenImg, 465, -15, 1024, 1024);
      }

      const imgBase64 = screenshotCanvas
        .toDataURL("image/png", 1.0)
        .split(",")[1];

      // release memory
      screenshotCanvas.width = 1;
      screenshotCanvas.height = 1;

      api
        .setVizImage(imgBase64)
        .then((imgUrl) => {
          context.setUserProfile({
            ...context.userProfile,
            mostRecentImageUrl: imgUrl,
          });
          const img = new Image();
          img.src = imgUrl;
          // console.log('imgUrl: ', imgUrl)
        })
        .catch((e) => console.log("error: ,", e));
    });
  };
  /*
  const { mobile } = useTweaks(
    {
      ...makeSeparator(),
      ...makeButton("Generate Data", () => {
        const newData = generateData({});
        setData(newData);
      }),
      ...makeButton("Make screenshot", async () => {
        makeScreenshot();
      }),
      mobile: false,
    },
    [data]
  );
*/
  const setVisibleDate = (vizDate) => {
    const date = new Date(vizDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const dateFormatted = `${day < 10 ? "0" : ""}${day}/${
      month < 10 ? "0" : ""
    }${month}/${year}`;
    setDate(dateFormatted);
  };

  const context = useContext(SurveyContext);

  const api = new MacallanAPI(context.accessToken);

  useEffect(() => {
    window.addEventListener(
      "vizData",
      function (e) {
        setData(e.detail);
      },
      false
    );
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    const largeScreenMediaQuery = window.matchMedia("(min-width: 768px)");
    const verticalVizMediaQuery = window.matchMedia("(max-width: 991px)");
    const setLargeScreenMediaQuery = () => {
      setIsLargeScreen(largeScreenMediaQuery.matches);
    };

    const setVerticalVizMediaQuery = () => {
      setIsVerticalViz(verticalVizMediaQuery.matches);
    };

    try {
      largeScreenMediaQuery.addEventListener(
        "change",
        setLargeScreenMediaQuery
      );
      verticalVizMediaQuery.addEventListener(
        "change",
        setVerticalVizMediaQuery
      );
    } catch {
      largeScreenMediaQuery.addListener(setLargeScreenMediaQuery);
      verticalVizMediaQuery.addListener(setVerticalVizMediaQuery);
    }

    return () => {
      try {
        largeScreenMediaQuery.removeEventListener(
          "change",
          setLargeScreenMediaQuery
        );
        verticalVizMediaQuery.removeEventListener(
          "change",
          setVerticalVizMediaQuery
        );
      } catch {
        largeScreenMediaQuery.removeListener(setLargeScreenMediaQuery);
        verticalVizMediaQuery.removeListener(setVerticalVizMediaQuery);
      }
    };
  }, []);

  const setParams = function (tempParams = {}) {
    async function getData() {
      // get the data
      let tempData;
      if (context.userProfile?.answers) {
        const vizData = await calcVisualisationData(
          context,
          context.userProfile?.answers,
          tempParams
        );
        tempData = vizData.data;
        setDataChanged(vizData.dataChanged);
        setVisibleDate(vizData.date);
      } else {
        return;
      }
      // console.log("Viz data with top cardinalities", data);
      if (debugCalculationsRef.current) {
        const oldValue = JSON.stringify(debugCalculationsRef.current.value);
        const newValue = JSON.stringify(tempData);
        if (oldValue !== newValue) {
          debugCalculationsRef.current.value = newValue;
        }
      }
      setData(tempData);

      if (tempData?.calculations) {
        const slides = [];
        tempData.calculations.topCardinalities.forEach((c) => {
          const ch = characteristics[c.cardinality];
          if (ch) {
            slides.push({
              title: t(ch.title),
              text: t(ch[c.level]),
              icon: ch.icon,
            });
          }
        });
        if (slides.length) {
          setSlideContent(slides);
        }
      }
    }

    getData();
  };

  useEffect(() => {
    setParams();
  }, []);

  useEffect(() => {
    setAppBackground("Ring_Viz_BG_v2.png", isLoading ? 0.7 : 0);
  }, [isLoading]);

  useEffect(() => {
    //console.log("STAGE CHANGED: ", stage);
    if (stage !== "") {
      setIsLoading(false);
    }

    if (stage === "done") {
      context.setVizAnimated(true);
    }

    if (
      stage === "done" &&
      context.userProfile?.percentageCompletionValues?.overall > 0 &&
      (dataChanged || context?.storedData.vizImgIsDesktop !== isLargeScreen)
    ) {
      makeScreenshot();

      api.setConfig({
        ...context.storedData,
        vizImgIsDesktop: isLargeScreen,
      });
    }
  }, [stage]);
  //context.vizAnimated

  const controlButtons =
    context.vizAnimated || skipped ? (
      <div className="rings__controls">
        <button
          onClick={() => {
            setSkipped(false);
            context.setVizAnimated(false);
            setReset(reset + 1);
          }}
          className="rings__control-button rings__control-button--playagain"
        >
          {t("button.play_again")}
        </button>
      </div>
    ) : (
      <div className="rings__controls">
        <button
          onClick={() => {
            setPaused(!paused);
          }}
          className={`rings__control-button rings__control-button--playpause ${
            !paused ? " paused" : ""
          }`}
        >
          {paused ? t("button.resume") : t("button.pause")}
        </button>
        <button
          onClick={() => {
            setSkipped(true);
          }}
          className="rings__control-button rings__control-button--skip"
        >
          {t("button.skip")}
        </button>
      </div>
    );

  return (
    <>
      <BodyClassName className="body-rings" />
      {isLoading && <Loader text={t("app.loading")} />}
      <div
        className="rings"
        style={{
          display: isLoading ? "none" : isVerticalViz ? "block" : "flex",
        }}
      >
        <RingsView
          date={date}
          username={context.userProfile?.firstName}
          slides={slideContent}
          isLargeScreen={isLargeScreen}
          isVerticalViz={isVerticalViz}
          stage={stage}
          image={context.userProfile.mostRecentImageUrl}
        >
          {data?.rings?.length && (
            <>
              {controlButtons}
              <Visualisation
                finished={context.vizAnimated || skipped}
                canvasRef={canvasRef}
                paused={paused}
                reset={reset}
                data={data} //props.data ||
                mobile={!isLargeScreen}
                onStageChange={({ stage }) => {
                  setStage(stage);
                }}
              />
            </>
          )}
        </RingsView>
      </div>
      {process.env.REACT_APP_DEBUG === "1" &&
        data?.rings?.length &&
        !isLoading && (
          <>
            <textarea
              className="tp-area-helper"
              style={{ width: "100%", height: "300px" }}
              onBlur={(e) => {
                setData(JSON.parse(e.target.value));
              }}
              ref={debugCalculationsRef}
              defaultValue={JSON.stringify(data)}
            />
            <br />
            <textarea
              className="tp-area-helper"
              style={{ width: "100%", height: "100px" }}
              onBlur={(e) => {
                setParams(JSON.parse(e.target.value));
              }}
              defaultValue={JSON.stringify(defaultLevels)}
            />
          </>
        )}
    </>
  );
}
